<template>
  <div class="sing-reason" v-if="user_exam_detail_id">
    <div class="module-header-title">
      <span class="color-block"></span>
      <span>标记错因</span>
    </div>
    <div class="reason-info">
      <div class="reason-list">
        <span class="title">标记错因：</span>
        <span class="reason-1">
            <el-select v-model="first_reason.id" placeholder="请选择" @change="selectFirstReason">
            <el-option
              v-for="item in error_reason_list"
              :key="item.id"
              :label="item.reason"
              :value="item.id">
            </el-option>
          </el-select>
          </span>
        <span class="reason-2">
            <el-select v-model="second_reason.id" placeholder="请选择" @change="selectSecondReason">
            <el-option
              v-for="item in sub_error_reason_list"
              :key="item.id"
              :label="item.reason"
              :value="item.id">
            </el-option>
          </el-select>
          </span>
        <el-button type="primary" size="small" round plain @click="submitError">提交</el-button>
      </div>
      <div class="reason-count">
        <span class="title">错因统计：</span>
        <ul class="reason-item-ul">
          <li>
            <div class="reason-text">
              <span>错因一</span>
              <span>40%</span>
            </div>
          </li>
          <li>
            <div class="reason-text">
              <span>错因二</span>
              <span>35%</span>
            </div>
          </li>
          <li>
            <div class="reason-text">
              <span>错因三</span>
              <span>20%</span>
            </div>
          </li>
          <li>
            <div class="reason-text">
              <span>其他</span>
              <span>5%</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="error-reason-bg"></div>
    </div>
  </div>
</template>

<script>
  import { saveErrorReason } from '@/api/base';
  export default {
    name: "singReason",
    data () {
      return {
        first_reason: {
          id: '',
          name: ''
        },
        second_reason: {
          id: '',
          name: ''
        },
        sub_error_reason_list: [],
      }
    },
    props: {
      user_exam_detail_id: {
        required: true
      },
      error_reason_list: {
        required: true
      },
    },
    methods: {

      // 切换一级错因
      selectFirstReason () {
        this.error_reason_list.some(item => {
          if (item.id == this.first_reason.id) {
            this.sub_error_reason_list = item.sub_list;
            this.first_reason.name = item.reason;
          }
        })
      },

      // 切换二级错因
      selectSecondReason () {
        this.sub_error_reason_list.some(item => {
          if (item.id == this.second_reason.id) {
            this.second_reason.name = item.reason;
          }
        })
      },

      // 提交错因
      submitError() {
        let { subject_id, account_id } = this.$route.query;
        let params = {
          subject_id: subject_id,
          account_id: account_id,
          user_exam_detail_id: this.user_exam_detail_id,
          first_reason_id: this.first_reason.id,
          first_reason: this.first_reason.name,
          second_reason_id: this.second_reason.id,
          second_reason: this.first_reason.name,
        }
        saveErrorReason(params).then(res => {
          if (res.code == 0) {
            console.log('提交错因成功')
          }
        })
      }

    }
  }
</script>

<style scoped lang="scss">
  .sing-reason {
    margin-top: 28px;
    .reason-info {
      position: relative;
      margin-top: 11px;
      background-image: linear-gradient(-180deg, #FFFFFF 0%, #F1F9FF 100%);
      border: 1px solid #DEE5F0;
      .title {
        margin-right: 10px;
        font-size: 14px;
        color: #606B7D;
      }
      .reason-list {
        margin: 37px 0 0 29px;
        .reason-1 {
          margin-right: 10px;
        }
        .reason-2 {
          margin-right: 17px;
        }
      }
      .reason-count {
        display: flex;
        align-items: center;
        margin: 21px 0 38px 29px;
        .reason-item-ul {
          li {
            float: left;
            margin-right: 5px;
            .reason-text {
              font-size: 12px;
              color: #606B7D;
            }
          }
        }
      }
      .error-reason-bg {
        position: absolute;
        width: 296px;
        height: 130px;
        top: 10px;
        right: 29px;
        background: url('~@/assets/images/error_reason.png') no-repeat center;
        background-size: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/singReason.vue